import type { CorridorIncident } from '@/types/corridor';

export const CORRIDOR_INCIDENTS: CorridorIncident[] = [
  {
    id: 'inc-01-marea-blanca',
    operation: 'Operation MAREA BLANCA',
    date: '2026-01-06T00:00:00Z',
    lat: 27.0,
    lng: -18.5,
    seizure_kg: 9994,
    method: 'container',
    vessel_name: 'MV United S',
    vessel_flag: 'CM', // Cameroon
    description:
      'Largest cocaine seizure at sea in Spanish history. 9,994 kg in 294 bales concealed beneath salt cargo. Vessel route: Turkey\u2192Libya\u2192Morocco\u2192Brazil\u2192Suriname\u2192Canaries. 13 crew arrested (7 Indian, 4 Turkish, 2 Serbian). Vessel linked to Turkish figure \u00c7etin G\u00f6ren.',
    sources: ['MAOC-N', 'CBSNews', 'Euronews', 'Maritime Executive', 'Nordic Monitor'],
    interdicting_forces: 'Spanish National Police GEO, Spanish Navy, SASEMAR',
  },
  {
    id: 'inc-02-monterrey',
    operation: 'Operation MONTERREY',
    date: '2026-01-12T00:00:00Z',
    lat: 42.24,
    lng: -8.72,
    seizure_kg: 200,
    method: 'container',
    vessel_name: undefined,
    vessel_flag: undefined,
    description:
      'Container ship on "fruit route" from Latin America/Ecuador. 200 kg in 4 bales via "gancho ciego" (blind hook) method \u2014 cocaine hidden in fruit peel container. Albanian clan linked to late British drug lord Brian Colin Charrington. 8 arrested (3 Albanian, 1 French, 1 Latvian).',
    sources: ['Agencia Tributaria', 'Infobae Espa\u00f1a', 'Diario de Pontevedra'],
    interdicting_forces: 'Polic\u00eda Nacional GRECO Galicia / UDYCO Central',
  },
  {
    id: 'inc-03-uscg-puerto-rico-1',
    operation: 'USCG Interdiction (Vega Baja)',
    date: '2026-01-14T00:00:00Z',
    lat: 19.0,
    lng: -66.4,
    seizure_kg: 506,
    method: 'go_fast',
    vessel_name: undefined,
    vessel_flag: undefined,
    description:
      '25-foot blue-and-white panga-style go-fast boat intercepted north of Puerto Rico. 506 kg in 16 bales, valued >$7 million. 3 men detained. Detected by HC-144 Ocean Sentry aircraft during routine patrol.',
    sources: ['gCaptain', 'GlobalSecurity.org', 'CBS12'],
    interdicting_forces: 'USCG Station San Juan, USCG Cutter Joseph Tezanos, CBP Caribbean Air and Marine Branch',
  },
  {
    id: 'inc-04-trepadores',
    operation: 'Balkan Cartel "Trepadores" Network',
    date: '2026-01-15T00:00:00Z',
    lat: 36.1,
    lng: -5.4,
    seizure_kg: 2475,
    method: 'container',
    vessel_name: undefined,
    vessel_flag: undefined,
    description:
      'Three organizations dismantled: Balkan Cartel (drug owners), Colombian ship-loading org, Spanish logistics network. "Trepadores" (climbers) \u2014 young Colombian swimmers loaded drugs onto container ships at sea. 30 persons arrested, war weapons seized. \u20ac166K cash, 8 vehicles, 215 gasoline cans, scaling ladders.',
    sources: ['Agencia Tributaria', 'Hacienda.gob.es', 'CBSNews'],
    interdicting_forces: 'Vigilancia Aduanera, Guardia Civil, Polic\u00eda Nacional',
  },
  {
    id: 'inc-05-adamastor',
    operation: 'Operation ADAMASTOR',
    date: '2026-01-24T00:00:00Z',
    lat: 38.5,
    lng: -31.0,
    seizure_kg: 9000,
    method: 'narco_sub',
    vessel_name: undefined,
    vessel_flag: undefined,
    description:
      'Largest cocaine seizure in Portuguese history. ~12m fiberglass semi-submersible (SPSS) painted to blend with ocean surface, intercepted 230 NM from Azores. ~9,000 kg in 300 bales (265 recovered, 35 sank). 4 crew (3 Colombian, 1 Venezuelan). Craft began sinking during boarding \u2014 agents formed human chain ankle-deep in seawater. Third SPSS intercepted by Portugal in ~12 months.',
    sources: ['MAOC-N', 'Euronews', 'CBSNews', 'Ports Europe', 'Small Wars Journal', 'InSight Crime'],
    interdicting_forces: 'Portuguese Judicial Police (UNCTE), Portuguese Navy NRP Corte-Real, Portuguese Air Force P-3C Orion',
  },
  {
    id: 'inc-06-cma-cgm-voltaire',
    operation: 'CMA CGM Voltaire Interception',
    date: '2026-01-26T00:00:00Z',
    lat: 12.5,
    lng: -74.2,
    seizure_kg: 2000,
    method: 'container',
    vessel_name: 'CMA CGM Voltaire',
    vessel_flag: 'MT', // Malta
    description:
      '6,500-TEU container ship (IMO 9635652) intercepted 60+ NM north of Santa Marta, Colombia. ~2,000 kg in 81 bundles + 4 loose bricks. Same vessel had 715 kg seized on identical Cartagena\u2013Algeciras route in July 2022. Owned by CMA CGM (Rodolphe Saad\u00e9). Cargo valued ~$200 million.',
    sources: ['Maritime Executive', 'Infobae Colombia', 'El Tiempo', 'VesselTracker'],
    interdicting_forces: 'Colombian Navy (Armada de Colombia), Colombian Aerospace Force',
  },
  {
    id: 'inc-07-ventose-caribbean',
    operation: 'FS Vent\u00f4se / Mission CARIB ROYAL',
    date: '2026-01-28T00:00:00Z',
    lat: 15.0,
    lng: -61.0,
    seizure_kg: 676.6,
    method: 'fishing_vessel',
    vessel_name: undefined,
    vessel_flag: 'BB', // Barbados
    description:
      'Fishing vessel (flag of Barbados) intercepted in Antilles maritime zone by French surveillance frigate FS Vent\u00f4se (F733). 676.6 kg in 30 bales. Intelligence from JIATF-South (US), DNRED (French customs intelligence), RSS, Barbados Coast Guard. Vessel handed to Barbadian authorities in Bridgetown.',
    sources: ['French Ministry of Defense'],
    interdicting_forces: 'Forces Arm\u00e9es aux Antilles (FAA), Marine nationale',
  },
  {
    id: 'inc-08-ventose-atlantic',
    operation: 'FS Vent\u00f4se / Mission CARIB ROYAL (mid-Atlantic)',
    date: '2026-02-01T00:00:00Z',
    lat: 20.0,
    lng: -40.0,
    seizure_kg: 1375,
    method: 'fishing_vessel',
    vessel_name: undefined,
    vessel_flag: 'BR', // Brazil
    description:
      "Brazilian fishing vessel heading toward Europe intercepted on high seas by FS Vent\u00f4se (F733). Second seizure of CARIB ROYAL mission. 1,375 kg, estimated value \u20ac41 million. Under authority of Pr\u00e9fet maritime de l'Atlantique (Brest). Crew remitted to Brazilian Federal Police at Port of Mucuripe, Fortaleza. Total CARIB ROYAL mission: >2 tonnes across two seizures.",
    sources: ['Mer et Marine', 'Franceinfo', 'France 3 Bretagne', 'defense.gouv.fr'],
    interdicting_forces: 'Marine nationale, Procureur de la R\u00e9publique (Brest)',
  },
  {
    id: 'inc-09-valhalla',
    operation: 'Operation VALHALLA',
    date: '2026-02-05T00:00:00Z',
    lat: 37.12,
    lng: -8.54,
    seizure_kg: 1384,
    method: 'sailboat',
    vessel_name: undefined,
    vessel_flag: undefined,
    description:
      'Cocaine transferred at sea from one vessel to a second that docked at Portim\u00e3o marina. 1,384 kg (~1.3 tonnes). 11 people arrested (9 Danish, 1 Latvian in Portim\u00e3o; 1 in Copenhagen). Criminal organization used a funeral hearse to transport cocaine from marina to safe house. Investigation triggered by Danish alert. Final destination: Denmark/Nordic market.',
    sources: ['The Portugal News', 'Portugal Resident', 'Sul Informa\u00e7\u00e3o', 'MAOC-N'],
    interdicting_forces: 'Portuguese Judicial Police (UNCTE), Pol\u00edcia Mar\u00edtima, Danish Police, Spanish National Police',
  },
  {
    id: 'inc-10-uscg-fort-lauderdale',
    operation: 'USCG Fort Lauderdale Dual Interdiction',
    date: '2026-02-09T00:00:00Z',
    lat: 26.09,
    lng: -80.11,
    seizure_kg: 338,
    method: 'go_fast',
    vessel_name: undefined,
    vessel_flag: undefined,
    description:
      'Two suspected smuggling boats intercepted near Port Everglades, Fort Lauderdale \u2014 first vessel near sea buoy (Feb 9), second 7 miles east (Feb 11). Combined ~338 kg (~745 lbs), valued $5.6 million.',
    sources: ['Space Coast Daily', 'CBS12'],
    interdicting_forces: 'USCG Station Fort Lauderdale, CBP Office of Field Operations, HSI',
  },
  {
    id: 'inc-11-uscg-camuy',
    operation: 'USCG Interdiction (Camuy)',
    date: '2026-02-13T00:00:00Z',
    lat: 19.8,
    lng: -66.85,
    seizure_kg: 945,
    method: 'go_fast',
    vessel_name: undefined,
    vessel_flag: undefined,
    description:
      'Panga-style go-fast vessel carrying bales and fuel containers, 100 NM north of Camuy, Puerto Rico. ~945 kg in 29 bales, valued $13.3 million. Suspects began evasive maneuvers, jettisoned cargo, fled. All 29 bales recovered from water. Abandoned go-fast found ashore near Arecibo.',
    sources: ['GlobalSecurity.org', 'HSToday'],
    interdicting_forces: 'USCG Cutter Joseph Napier, USCG Air Station Miami (HC-144 Ocean Sentry), CBP, HSI San Juan',
  },
  {
    id: 'inc-12-vigo-second',
    operation: 'Port of Vigo Second Seizure',
    date: '2026-02-15T00:00:00Z',
    lat: 42.24,
    lng: -8.72,
    seizure_kg: 80,
    method: 'container',
    vessel_name: undefined,
    vessel_flag: undefined,
    description:
      'Container ship from Ecuador \u2014 cocaine hidden in refrigeration system machinery. 80+ kg (70 packages). 2 Albanian nationals detained while attempting to access container in early hours. Second cocaine seizure at Port of Vigo in 2026 (after Op. Monterrey). Both Vigo seizures involved Albanian nationals.',
    sources: ['Galicia Press'],
    interdicting_forces: 'Guardia Civil, Servicio de Vigilancia Aduanera',
  },
];
